import React, { useState, useEffect } from 'react';
import logo from '../assets/logo.svg';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navBg = scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent';
  const textColor = scrolled ? 'text-gray-900' : 'text-white';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
      <div className="h-16 flex items-center justify-between" style={{ paddingLeft: '7vw', paddingRight: '7vw' }}>
        {/* Logo */}
        <a href="#top" className="flex-shrink-0 flex items-center gap-2.5">
          <img src={logo} alt="" className="h-9 w-9 rounded-xl" />
          <span className={`${textColor} text-2xl tracking-tight transition-colors duration-300`}>
            <span className="font-extrabold">Smile</span>
            <span className="font-light">Africa</span>
          </span>
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          <a
            href="#how-it-works"
            className={`${textColor} hover:opacity-70 text-sm font-semibold tracking-widest transition-all duration-300`}
          >
            HOW IT WORKS
          </a>
          <a
            href="#faq"
            className={`${textColor} hover:opacity-70 text-sm font-semibold tracking-widest transition-all duration-300`}
          >
            FAQ
          </a>
          <a
            href="#download"
            className="text-white text-xs font-bold tracking-widest pl-5 pr-2 py-2 rounded-full flex items-center gap-3 transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#ea3d05' }}
          >
            DOWNLOAD APP
            <span className="w-7 h-7 rounded-full bg-black text-white flex items-center justify-center text-sm font-black">
              →
            </span>
          </a>
        </div>

        {/* Hamburger */}
        <button
          className={`md:hidden ${textColor} p-2 transition-colors duration-300`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/98 backdrop-blur-md border-t border-gray-100 py-5 flex flex-col gap-4" style={{ paddingLeft: '7vw', paddingRight: '7vw' }}>
          <a
            href="#how-it-works"
            className="text-gray-700 text-sm font-semibold tracking-widest"
            onClick={() => setMenuOpen(false)}
          >
            HOW IT WORKS
          </a>
          <a
            href="#faq"
            className="text-gray-700 text-sm font-semibold tracking-widest"
            onClick={() => setMenuOpen(false)}
          >
            FAQ
          </a>
          <a
            href="#download"
            className="text-white text-sm font-bold tracking-widest px-5 py-3 rounded-full text-center"
            style={{ backgroundColor: '#ea3d05' }}
            onClick={() => setMenuOpen(false)}
          >
            DOWNLOAD APP →
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
